import React, { useState } from "react";
import { X } from "lucide-react";
import { gallery } from "../mock";
import { useReveal } from "../hooks/useReveal";
import { useSettings } from "../context/SettingsContext";

export default function Gallery() {
  const { ref, inView } = useReveal();
  const [active, setActive] = useState(null);
  const settings = useSettings();
  const items = settings?.galleryItems?.length
    ? settings.galleryItems.filter((g) => g.image).map((g) => ({ src: g.image, caption: g.caption }))
    : gallery;

  return (
    <section id="gallery" className="relative py-24 bg-background">
      <div className="max-w-7xl mx-auto px-5">
        <div ref={ref} className={`reveal ${inView ? "in-view" : ""}`}>
          <div className="flex items-center gap-3 mb-4">
            <span className="h-[2px] w-10 bg-gold" />
            <span className="section-label text-gold text-xs">Gallery</span>
          </div>
          <h2 className="display-font uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            Club <span className="text-gold">photos.</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mt-14">
          {items.map((g, i) => (
            <button
              key={g.src || i}
              onClick={() => setActive(g)}
              className={`group relative overflow-hidden rounded-lg border border-white/10 ${
                i === 0 ? "lg:col-span-2 lg:row-span-2" : ""
              }`}
            >
              <img
                src={g.src}
                alt={g.caption}
                className={`w-full object-cover group-hover:scale-105 transition-transform duration-500 ${
                  i === 0 ? "h-full min-h-[300px] lg:min-h-[520px]" : "h-52 lg:h-64"
                }`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              <span className="absolute bottom-4 left-4 cond-font uppercase tracking-widest text-sm text-white opacity-0 group-hover:opacity-100 transition-opacity text-left">
                {g.caption}
              </span>
            </button>
          ))}
        </div>
      </div>

      {active && (
        <div
          className="fixed inset-0 z-[60] bg-black/90 backdrop-blur-sm flex items-center justify-center p-5"
          onClick={() => setActive(null)}
        >
          <button className="absolute top-6 right-6 text-white/70 hover:text-gold" onClick={() => setActive(null)}>
            <X size={32} />
          </button>
          <div className="max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={active.src} alt={active.caption} className="w-full rounded-lg" />
            <p className="cond-font uppercase tracking-widest text-center text-gold mt-4">{active.caption}</p>
          </div>
        </div>
      )}
    </section>
  );
}
